(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

  function getActivePanel(root) {
    return root.querySelector('[data-la-panel]:not(.is-hidden)');
  }
  function getScroller(panel) {
    return panel && panel.querySelector('.livia-classic__scroller');
  }
  function getCardWidth(scroller) {
    var card = scroller.querySelector('.livia-classic__card');
    return card ? card.getBoundingClientRect().width : scroller.clientWidth;
  }
  function visibleCount(scroller) {
    var w = getCardWidth(scroller);
    return Math.max(1, Math.round(scroller.clientWidth / w));
  }
  function totalCards(scroller) {
    return scroller.querySelectorAll('.livia-classic__card').length;
  }
  function pageCount(scroller) {
    var total = totalCards(scroller);
    var vis = visibleCount(scroller);
    return Math.max(1, total - vis + 1);
  }
  function currentPage(scroller) {
    return Math.round(scroller.scrollLeft / getCardWidth(scroller));
  }

  function buildDots(panel) {
    var dotsEl = panel.querySelector('[data-la-dots]');
    var scroller = getScroller(panel);
    if (!dotsEl || !scroller) return;
    var pages = pageCount(scroller);
    dotsEl.innerHTML = '';
    if (pages <= 1) { dotsEl.style.display = 'none'; return; }
    dotsEl.style.display = '';
    for (var i = 0; i < pages; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'livia-classic__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Strona ' + (i + 1));
      b.dataset.page = i;
      dotsEl.appendChild(b);
    }
  }
  function syncDots(panel) {
    var scroller = getScroller(panel);
    var dotsEl = panel.querySelector('[data-la-dots]');
    if (!scroller || !dotsEl) return;
    var page = currentPage(scroller);
    dotsEl.querySelectorAll('.livia-classic__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === page);
    });
  }
  function syncNav(root) {
    var panel = getActivePanel(root);
    var scroller = getScroller(panel);
    var prev = root.querySelector('[data-la-nav="prev"]');
    var next = root.querySelector('[data-la-nav="next"]');
    if (!scroller || !prev || !next) return;
    var max = scroller.scrollWidth - scroller.clientWidth;
    prev.disabled = scroller.scrollLeft <= 2;
    next.disabled = max - scroller.scrollLeft <= 2;
  }

  function scrollByCards(scroller, dir) {
    var w = getCardWidth(scroller);
    scroller.scrollBy({ left: dir * w, behavior: scrollBehavior });
  }

  function initClassic(root) {
    var tabs = root.querySelectorAll('[data-la-tab]');
    var panels = root.querySelectorAll('[data-la-panel]');

    panels.forEach(function (panel) {
      buildDots(panel);
      var scroller = getScroller(panel);
      if (scroller) {
        scroller.addEventListener('scroll', function () {
          syncDots(panel);
          syncNav(root);
        }, { passive: true });
      }
      var dotsEl = panel.querySelector('[data-la-dots]');
      if (dotsEl) {
        dotsEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.livia-classic__dot');
          if (!btn || !scroller) return;
          var page = parseInt(btn.dataset.page, 10) || 0;
          scroller.scrollTo({ left: page * getCardWidth(scroller), behavior: scrollBehavior });
        });
      }
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-la-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-hidden', p.getAttribute('data-la-panel') !== id);
        });
        requestAnimationFrame(function () {
          var active = getActivePanel(root);
          if (active) { buildDots(active); syncDots(active); }
          syncNav(root);
        });
      });
    });

    root.querySelectorAll('[data-la-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = getActivePanel(root);
        var scroller = getScroller(panel);
        if (!scroller) return;
        scrollByCards(scroller, btn.getAttribute('data-la-nav') === 'next' ? 1 : -1);
      });
    });

    window.addEventListener('resize', function () {
      panels.forEach(buildDots);
      syncNav(root);
    });

    syncNav(root);
  }

  function init() {
    document.querySelectorAll('.livia-classic').forEach(initClassic);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
